import type {
  CatalogListOptions,
  CatalogPage,
  CatalogRepository,
} from '#/domain/catalog/CatalogRepository'
import type { CatalogMetric } from '#/domain/catalog/CatalogMetric'

export class GetMetricByOrgIdUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    organizationId: string,
    options: CatalogListOptions,
    applicationId?: string,
    search?: string,
  ): Promise<CatalogPage<CatalogMetric>> {
    return this.repository.findMetricsByOrganizationId(
      organizationId,
      options,
      applicationId,
      search,
    )
  }
}
